// Import helpers
import { getErrorCodeResults } from 'helpers/error_code_api';
import { subscriberParentalDisable, subscriberParentalEnable } from 'helpers/api/subscriber';
import { setUserToken } from 'helpers/auth';

// Import types
import type { AxiosErrorResponse } from 'types/api/errors';
import type { ParentalToggleParams } from 'types/views/parental_control';
import type { AppDispatch } from 'store/store';

// Import actions
import { parentalControlLoading, parentalControlSuccess, parentalControlError } from './actions';

// ******************** ENABLE PARENTL CONTROL ********************
export const enableParentalControl =
	({ values, isEnabled, callback = () => {} }: ParentalToggleParams) =>
	async (dispatch: AppDispatch) => {
		try {
			// Dispatch an loading action
			dispatch(parentalControlLoading(true));

			const response = isEnabled ? await subscriberParentalDisable(values.pin as string) : await subscriberParentalEnable(values.rating as number);

			setUserToken(response.data.token);

			dispatch(parentalControlSuccess(response.data));

			// Close form modal callback
			callback();

			// reload whole app to apply parental control across all requests and components
			window.location.reload();
		} catch (err) {
			const error = err as AxiosErrorResponse;
			if (error.response) {
				const { codeErrorMessage } = getErrorCodeResults(error);

				error.response.data.message = codeErrorMessage;

				// Dispatch an error action
				dispatch(parentalControlError(error.response));
			}
		}
	};
